import { EventEmitter } from "events"

const AuthEvents = new EventEmitter()

const UNAUTHORIZED_EVENT = "Unauthorized" as const

export { AuthEvents, UNAUTHORIZED_EVENT }
